var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-progress-container"},[_c('div',{staticClass:"step-progress-wrapper"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step-item-wrapper"},[_c('div',{staticClass:"step-item",class:{
          'is-active': index === _vm.currentStep,
          'is-completed': index < _vm.currentStep,
          'is-clickable': _vm.clickable
        },on:{"click":function($event){return _vm.handleStepClick(index)}}},[_c('div',{staticClass:"step-content"},[_c('span',{staticClass:"step-text"},[_vm._v(_vm._s(step.label))])])]),(index < _vm.steps.length - 1)?_c('div',{staticClass:"step-arrow",class:{
          'is-active': index < _vm.currentStep
        }},[_c('img',{staticClass:"step-arrow-img",attrs:{"src":require("@/assets/img/step-arrow.png"),"alt":"arrow"}})]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }